import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const Seo = () => {
  const location = useLocation();
  const canonicalUrl = `${window.location.origin}${location.pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
      <meta name="description" content="SkyAzúl Equipment Solutions is a trusted leader in sales and service of advanced monitoring systems for construction and mining equipment worldwide. Call @ (301) 371-6126
"/>
      <meta name="keywords" content="" />
    </Helmet>
  );
};

export default Seo;
